import React from "react";
//#region types
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { useFloatingMessages } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

interface WintSalaryApprovalAlertsProps {
  hasAlreadyApprovedExtras: boolean;
}

const WintSalaryApprovalAlerts: React.FC<WintSalaryApprovalAlertsProps> = ({ hasAlreadyApprovedExtras }) => {
  const { enqueueMessage } = useFloatingMessages();

  React.useEffect(() => {
    if (hasAlreadyApprovedExtras) {
      enqueueMessage(
        LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SalaryDeviation.WintTodoExtraSalaryNotice),
        StyleEnums.DisplayType.Info
      );
    }
  }, [hasAlreadyApprovedExtras]);

  return <></>;
};

export default WintSalaryApprovalAlerts;
